export default "__VITE_ASSET__D7z3ey2b__"